module.exports = __webpack_public_path__ + "static/media/logo.728c33ce.png";